import React from "react";
const ctx = document.createElement("canvas").getContext("2d");
const gradient = ctx.createLinearGradient(0, 0, 0, 400);
gradient.addColorStop(0, "rgba(2, 139, 232, 0.2)");
gradient.addColorStop(1, "rgba(2, 139, 232, 0)");
const specialtiesData = {
  specialty1: {
    label: "Specialty 1",
    data: [30, 40, 35, 50, 45, 60], // Replace this with your actual data for Specialty 1
    borderColor: "#1DE5EC",
    backgroundColor: "#1DE5EC",
  },
  specialty2: {
    label: "Specialty 2",
    data: [20, 35, 25, 40, 30, 50], // Replace this with your actual data for Specialty 2
    borderColor: "rgba(54, 162, 235, 1)",
    backgroundColor: "rgba(54, 162, 235, 0.2)",
  },
  // Add more specialties if needed
};
export const dummyData = {
  claimTrends: {
    // title: "Claim Trends Forecast",
    MonthlyClaimTrendsChart: [
      "Claim Trends",
      {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          // "",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        datasets: [
          {
            // label: "Claims",
            // data: [1200000, 190000, 300000, 50000, 1200000, 3000], // Replace this with your actual data
            label: "Current",
            backgroundColor: "#039BFF",
            borderColor: "#039BFF",
            hoverBackgroundColor: "#039BFF",
            hoverBorderColor: "#039BFF",
            data: [
              129200,
              113400,
              110000,
              114600,
              120400,
              // null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
            ],
            // fill: false,
            // backgroundColor: "#039BFF",
            // borderColor: "#039BFF",
          },

          {
            label: "Forecasted",
            backgroundColor: "#1DE5EC",
            borderColor: "#1DE5EC", // Specify color directly here
            hoverBackgroundColor: "#1DE5EC",
            hoverBorderColor: "#1DE5EC",
            data: [
              null,
              null,
              null,
              null,
              null,
              // null,
              119000,
              120700,
              117200,
              127200,
              130100,
              120800,
              138800,
            ],
          },
        ],
      },
      {
        indexAxis: "x",
        scales: {
          x: {
            beginAtZero: true,
          },
        },
        plugins: {
          legend: {
            position: "bottom",
          },
        },
      },
      "line",
      { w: 6, h: 5, x: 0, y: 0 },
    ],
    // HistoricalClaimCountChart: [
    //   "Monthly Claim Amount Analysis",
    //   {
    //     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    //     datasets: [
    //       {
    //         label: "Claim Amounts",
    //         data: [2000, 2500, 1800, 3000, 2200, 2700], // Replace this with your actual data
    //         backgroundColor: "#028BE8",
    //         borderColor: "rgba(54, 162, 235, 1)",
    //         borderWidth: 1,
    //       },
    //     ],
    //   },
    //   {
    //     indexAxis: "x",
    //     scales: {
    //       y: {
    //         beginAtZero: true,
    //       },
    //     },
    //     plugins: {
    //       legend: {
    //         position: "bottom",
    //       },
    //     },
    //   },
    //   "bar",
    //   { w: 6, h: 5, x: 6, y: 0 },
    // ],
  },
  memberShip: {
    GrowthMemberPolicies: [
      "Policy Trends",
      {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],

        datasets: [
          {
            label: "Current",
            backgroundColor: "#039BFF",
            borderColor: "#039BFF",
            borderWidth: 1,
            hoverBackgroundColor: "#039BFF",
            hoverBorderColor: "#039BFF",
            data: [
              100,
              90,
              140,
              160,
              180,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
            ],
          },
          {
            label: "Forecasted",
            backgroundColor: "#1DE5EC",
            borderColor: "#1DE5EC", // Specify color directly here
            hoverBackgroundColor: "#1DE5EC",
            hoverBorderColor: "#1DE5EC",
            data: [
              null,
              null,
              null,
              null,
              null,
              null,
              280,
              200,
              320,
              340,
              360,
              null,
              null,
            ],
          },
          // {
          //   label: "Historical Data",
          //   data: [100, 120, 140, 160, 180, 200, 220, 240, 260, 280],
          //   borderColor: "#039BFF",
          //   backgroundColor: "#039BFF",
          // },
          // {
          //   label: "Projected Data",
          //   data: [280, 300, 320, 340, 360, 380, 400, 420, 440, 460],
          //   borderColor: "#1DE5EC",
          //   backgroundColor: "#1DE5EC",
          // },
        ],
      },
      {
        scales: {
          x: {
            stacked: false,
          },
          y: {
            stacked: false,
          },
        },
        plugins: {
          legend: {
            position: "bottom",
          },
        },
      },
      "bar",
      { w: 6, h: 5, x: 6, y: 0 },
    ],
  },
  providers: {
    // title: "Provider Numbers Forecast",
    ProviderNumber: [
      "Provider Network Growth",
      {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        datasets: [
          {
            label: "Current",
            backgroundColor: "#039BFF",
            borderColor: "#039BFF",
            borderWidth: 1,
            hoverBackgroundColor: "#039BFF",
            hoverBorderColor: "#039BFF",
            data: [
              28,
              48,
              40,
              19,
              66,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
            ],
          },
          {
            label: "Forecasted",
            backgroundColor: "#1DE5EC",
            borderColor: "#1DE5EC", // Specify color directly here
            hoverBackgroundColor: "#1DE5EC",
            hoverBorderColor: "#1DE5EC",
            data: [
              null,
              null,
              null,
              null,
              null,
              null,
              59,
              80,
              81,
              56,
              65,
              null,
              null,
            ],
          },
        ],
      },
      {
        scales: {
          x: {
            stacked: false,
          },
          y: {
            stacked: false,
          },
        },
        plugins: {
          legend: {
            position: "bottom",
          },
        },
      },
      "bar",
      { w: 6, h: 5, x: 0, y: 5 },
    ],
  },
};
